const ComparisonReport = () => import('./ComparisonReport.vue')

export const COMPARISON_REPORT_ROUTES = [
	{
		path: '/comparison_report',
		component: ComparisonReport
	}
]
